import { IHydraRestaurant } from './../../../api/models/hydra-api-models';
import { AuthActions, AuthActionTypes } from '../actions/auth.action';
import { ManageBusinessData, LocationData } from '@app/api/models/api-models';
import { LanguageCodes } from '@app/core/utils/translate-const';

export interface AuthState {
  claimData: ManageBusinessData;
  requestBody: LocationData;
  restaurantAssistent: IHydraRestaurant;
  loading: boolean;
  redirectUrl: any;
  hasManageError: boolean;
  errorMessage: string | string[];
  language: string;
  showNavMenu: boolean;
  isBusinessFromHydra: boolean;
  isAfterOnboardingWizard: boolean;
}

const initialState: AuthState = {
  claimData: null,
  requestBody: null,
  restaurantAssistent: null,
  loading: false,
  redirectUrl: null,
  hasManageError: false,
  errorMessage: null,
  showNavMenu: true,
  language: 'en',
  isBusinessFromHydra: false,
  isAfterOnboardingWizard: false,
};

export function AuthReducer(state = initialState, action: AuthActions): AuthState {
  switch (action.type) {
    case AuthActionTypes.MANAGE_BUSINESS_ATTEMPT: {
      return Object.assign({}, state, {
        loading: true,
      });
    }

    case AuthActionTypes.MANAGE_BUSINESS_SUCCESS: {
      return {
        ...state,
        loading: false,
        hasManageError: false,
        isAfterOnboardingWizard: true,
      };
    }

    case AuthActionTypes.MANAGE_BUSINESS_FAILURE: {
      return { ...state, hasManageError: true, loading: false, errorMessage: action.payload.error };
    }

    case AuthActionTypes.ERROR_LAYOUT_SHOW: {
      return {
        ...state,
        errorMessage: action.payload.error,
      };
    }

    case AuthActionTypes.ERROR_LAYOUT_HIDE: {
      return Object.assign({}, state, {
        errorOpened: false,
        errorStatus: 0,
        errorLabel: '',
      });
    }

    case AuthActionTypes.NAV_MENU_LAYOUT_SHOW: {
      return {
        ...state,
        showNavMenu: true,
      };
    }

    case AuthActionTypes.NAV_MENU_LAYOUT_HIDE: {
      return {
        ...state,
        showNavMenu: false,
      };
    }

    case AuthActionTypes.CHANGE_LANGUAGE: {
      const { language: selectedLanguage } = action.payload;
      const language = LanguageCodes[selectedLanguage];
      return { ...state, language };
    }

    case AuthActionTypes.BUSINESS_FROM_HYDRA: {
      return { ...state, isBusinessFromHydra: action.payload.isBusinessFromHydra };
    }

    default:
      return state;
  }
}
